import LeaEditTable from "./edit-table";
import LeaEditTableColumn from "./edit-table-column";
import LeaEditTableInput from "./edit-table-input";

const components = [LeaEditTable, LeaEditTableColumn, LeaEditTableInput];

export const install = function(Vue) {
  components.map(component => {
    Vue.component(component.name, component);
  });
};
